// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileUnknownTwoToneSvg from "@ant-design/icons-svg/es/asn/FileUnknownTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileUnknownTwoTone = function FileUnknownTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownTwoToneSvg
  }));
};

FileUnknownTwoTone.displayName = 'FileUnknownTwoTone';
export default React.forwardRef(FileUnknownTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileUnknownTwoTone.js
// module id = 1155
// module chunks = 0